import axios from "axios";
import { SCHEDULE, SCHEDULE_LOADING, SCHEDULE_IS_ARCHIVE } from "../constants/schedule";
import { API_URL } from "../config/config";
import { SOURCE } from "../constants/global";

export function fetchSchedule(locale) {
  return (dispatch) => {
    dispatch(scheduleAreLoading(true));

    const config = { params: { source: SOURCE, locale: locale } };

    axios
      .get(`${API_URL}user/timetable`, config)
      .then((response) => {
        dispatch(scheduleSuccess(response.data.data));
        dispatch(scheduleIsArchive(response.data.meta.archive));
        dispatch(scheduleAreLoading(false));
        return response;
      })
      .catch((e) => console.log("error loading schedule", e));
  };
}

function scheduleAreLoading(bool) {
  return {
    type: SCHEDULE_LOADING,
    bool,
  };
}

function scheduleSuccess(data) {
  return {
    type: SCHEDULE,
    data,
  };
}

function scheduleIsArchive(bool) {
  return {
    type: SCHEDULE_IS_ARCHIVE,
    bool,
  };
}
